// based on the faceplate-path.svg file
export const faceplateLeftPoints = [
    [446.292969, 887.203125],
    [434.546875, 838.320313],
    [403.707031, 802.523438],
    [371.898438, 783.773438],
    [307.410156, 789.96875],
    [313.8125, 755.445313],
    [313.8125, 687.574219],
    [296.246094, 622.953125],
    [296.246094, 601.789063],
    [349.296875, 488.460938],
    [390.578125, 393.691406],
    [396.232649, 382.057302],
    [400.608951, 373.497406],
    [403.707031, 368.011719],
    [406.805111, 362.526031],
    [411.246517, 355.472646],
    [417.03125, 346.851562],
    [434.546875, 340.285156],
    [468.617188, 346.851562],
    [521.398438, 368.011719],
    [591.296875, 411.082031],
    [664.402344, 469.589844],
    [716.101562, 540.082031],
    [739.765625, 589.84375],
    [745.328125, 658.003906],
    [739.765625, 705.304688],
    [716.101562, 755.445313],
    [687.09375, 789.96875],
    [655.214844, 814.191406],
    [585.949219, 821.183594],
    [531.457031, 838.320313],
    [491.148438, 853.800781],
    [446.292969, 887.203125]
];
